<template>
    <span class="gj-video-span">
        <span class="gj-video" @click="modalVisibleHandler">
            <img :src="videoSlateImgUrl" alt="">
            <img src="./../../assets/images/play.png" class="play" alt="">
        </span>
    </span>
</template>

<script>
import gjVideoModal from "./gj-video-modal"
export default {
    name: "gj-video",
    props: {
        videoSlateImgUrl: String,
        videoUrl: String
    },
    methods: {
        modalVisibleHandler() {
            const modal = this.$gjCreate(gjVideoModal, {
                props: {
                    content: '视频预览',
                    url: this.videoUrl
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.gj-video-span {
    display: inline-block;
    width: 40px;
    height: 40px;
}
.gj-video {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 40px;
    cursor: pointer;

    img {
        width: 100%;
        height: 100%;
        display: inline-block;
    }

    .play {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 22px;
        height: 22px;
        margin-left: -11px;
        margin-top: -11px;
    }
}
</style>